import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Button, Link, Paper, Stack, Typography } from '@mui/material'

import { getConsentDecision, recordConsentDecision } from 'common/consent'

// Bottom cookie / session-recording consent banner (Phase 1 of
// docs/SessionReplayConsentPlan.md). Copy is Appendix A verbatim — any change
// needs a plan-doc update and legal sign-off. Hidden for signed-in users
// because session recording consent is covered by the T&Cs they already
// accepted. Shown to anonymous visitors until a decision is made.
const ConsentBanner = () => {
  const { signedIn } = useSelector(state => state.identity)
  const [decision, setDecision] = useState(getConsentDecision)

  if (signedIn) {
    return null
  }

  if (decision) {
    return null
  }

  const handleDecision = value => {
    recordConsentDecision(value)
    setDecision(value)
  }

  return (
    <Paper
      elevation={4}
      square
      role='region'
      aria-label='Cookie and session recording consent'
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1201,
        px: { xs: 2, md: 4 },
        py: 2,
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', md: 'center' }}
        justifyContent='space-between'
      >
        <Typography variant='body2'>
          Cookies help the site function and let us understand how you use it. Session recording
          captures your clicks, scrolls, and navigation so we can improve your experience —
          sensitive personal information you type is always masked. We use cookies and session
          recording to improve your experience. Learn more in our{' '}
          <Link href='/privacy' target='_blank' rel='noopener noreferrer'>
            Privacy Policy
          </Link>
          .
        </Typography>
        <Stack direction='row' spacing={1} justifyContent={{ xs: 'flex-end', md: 'initial' }}>
          <Button variant='contained' onClick={() => handleDecision('accepted')}>
            Accept
          </Button>
          <Button variant='outlined' onClick={() => handleDecision('declined')}>
            Decline
          </Button>
        </Stack>
      </Stack>
    </Paper>
  )
}

export default ConsentBanner
